import { Component, OnInit, Input, Output } from '@angular/core';
import { TranslationService, Language } from 'app/shared/services/translation.service';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-translation-controls',
  templateUrl: './translation-controls.component.html',
  styleUrls: ['./translation-controls.component.scss'],
})
export class TranslationControlsComponent implements OnInit {
  @Input() language: Language;
  @Input() showTranslation: boolean;
  @Output() onLanguageChange = new EventEmitter<Language>();
  @Output() onShowTranslationChange = new EventEmitter<boolean>();
  
  ariaLabel = '';
  languages: Language[];

  constructor(private translationService: TranslationService) {}

  updateShowTranslation() {
    this.showTranslation = !this.showTranslation;
    this.onShowTranslationChange.emit(this.showTranslation);
  }

  updateSelectedLanguage(language: Language) {
    this.language = language;
    this.onLanguageChange.emit(language)
  }

  ngOnInit() {
    this.translationService.getLanguages().subscribe((languages) => {      
      this.languages = languages;
      const arr = this.languages;
      let i = this.languages.length;
  
      // Add language names/English names      
      while (i--) {
        arr[i].name = new (<any>Intl).DisplayNames([arr[i].language], {
          type: 'language',
        }).of(arr[i].language);
        arr[i].engName = new (<any>Intl).DisplayNames(['en'], {
          type: 'language',
        }).of(arr[i].language);
        if (arr[i].name === arr[i].language) {
          arr.splice(i, 1);
        }
      }
  
      // Sort languages by name, or if not in Latin alphabet, by English name, making sure English is first
      arr.sort(function (a, b) {
        if (a.name === 'English') {
          return -1; // English comes first
        }
        if (b.name === 'English') {
          return 1; // English comes first
        }        
        const alphabet = /^[a-zA-Z]+$/g;
        const nameA = a.name.match(alphabet)
          ? a.name.toUpperCase()
          : a.engName.toUpperCase();
        const nameB = b.name.match(alphabet)
          ? b.name.toUpperCase()
          : b.engName.toUpperCase();  
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });

      const engLabel = 'Select your language preference';
      
      if (this.language) {
        if (this.language.name === 'English') {
          this.ariaLabel = engLabel;
        } else {
          this.translationService
            .getTranslation(engLabel, this.language.language)
            .subscribe((res) => {
              this.ariaLabel = res;
            });
        }
      }
    });
  }
}
